export default {
  SET_CONFIG: 'SET_CONFIG',
  SET_PRODUCT_RESULTS: 'SET_PRODUCT_RESULTS',
  SET_PRODUCT_STATS: 'SET_PRODUCT_STATS',
  UPDATE_BALLS: 'UPDATE_BALLS',
  SET_BALLS: 'SET_BALLS',
  SET_ACTIVE_BETTING_TAB: 'SET_ACTIVE_BETTING_TAB',
  SET_COLOR_BET: 'SET_COLOR_BET',
  RESET_BALLS: 'RESET_BALLS',
  UPDATE_MOST_LEAST_DRAWN: 'UPDATE_MOST_LEAST_DRAWN',
  UPDATE_ROUND: 'UPDATE_ROUND',
  SET_DRAWN_COLOR: 'SET_DRAWN_COLOR',
  RESET_COLORS: 'RESET_COLORS',
  RESET_COLOR_BET: 'RESET_COLOR_BET',
  ADD_BETTING_TAB: 'ADD_BETTING_TAB',
  ALL_BETTING_DISABLED: 'ALL_BETTING_DISABLED',
  SET_CANCELED_TICKET: 'SET_CANCELED_TICKET',
  SET_PAYIN_DISABLED_FROM_SOCKET: 'SET_PAYIN_DISABLED_FROM_SOCKET',
  SET_LAST_SELECTED_BET: 'SET_LAST_SELECTED_BET',
  SET_HIDE_LOADER: 'SET_HIDE_LOADER',
  SET_DRAWN_BALLS_STATE_ACTIVE: 'SET_DRAWN_BALLS_STATE_ACTIVE',
  SET_TICKET_PAYIN_IN_PROG: 'SET_TICKET_PAYIN_IN_PROG',
  UPDATE_CONFIG: 'UPDATE_CONFIG',
  SET_NEXT_GEN_CONFIG: 'SET_NEXT_GEN_CONFIG',
  SET_PERNAMENT_BETTING_DISABLED: 'SET_PERNAMENT_BETTING_DISABLED',
  TOGGLE_FREE_BET_MODAL: 'TOGGLE_FREE_BET_MODAL',
  TOGGLE_FREE_BET_EXPIRED_MODAL: 'TOGGLE_FREE_BET_EXPIRED_MODAL',
  SET_LAST_DRAWN_BALL_ID: 'SET_LAST_DRAWN_BALL_ID',
  SET_NEXTGEN_STANDALONE_INTEGRATION: 'SET_NEXTGEN_STANDALONE_INTEGRATION',
  SET_ODDS: 'SET_ODDS',
  CLEAR_DRAWN_BALLS: 'CLEAR_DRAWN_BALLS',
  ADD_DRAWN_BALL: 'ADD_DRAWN_BALL',
  SET_BETTING_TAB_PROPERTIES: 'SET_BETTING_TAB_PROPERTIES',
  SET_BALL_PROPERTIES: 'SET_BALL_PROPERTIES',
  SET_LESS_THAN_SIX_BALLS_LEFT: 'SET_LESS_THAN_SIX_BALLS_LEFT',
  RESET_REMAINING_BALLS: 'RESET_REMAINING_BALLS',
  UPDATE_REMAINING_BALLS: 'UPDATE_REMAINING_BALLS',
};
